import { EventEmitter, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationApiService } from '../api/authentication-api.service';
import { NotificationService } from '../shared/components/notification/notification.service';
import { LoaderService } from '../shared/components/loader/loader.service';
import { Subject } from 'rxjs';
import { NavigationService } from './navigation.service';
import { menuRoles } from '../models/menu-roles';

const TOKEN_NAME = 'fppAccessToken';
const USER_NAME = 'fppUser';

@Injectable({
    providedIn: 'root',
})
export class AuthenticationService {

    userAuthenticatedChanged: EventEmitter<boolean> = new EventEmitter();
    peopleAccessBuilderAfterSalesSubject = new Subject<boolean>();


    constructor(
        private router: Router,
        private authenticationApi: AuthenticationApiService,
        private notificationService: NotificationService,
        private loaderService: LoaderService,
        private navigationService: NavigationService
    ) { }

    public async setUserFromUrl(accessToken: any) {
        let token = JSON.stringify({ token: accessToken });
        this._setAccessToken(token);
        this.loaderService.showLoader();
        await this._fetchAndSetCurrentUser();
        this.loaderService.hideLoader();
    }

    public isUserAuthenticated(): boolean {
        if (this.getAccessToken()) {
            return true;
        }
        return false;
    }

    public async login(email: string, password: string): Promise<any> {
        try {
            const accessToken = await this.authenticationApi.login(email, password);
            console.log(`token = ${accessToken}`);
            
            localStorage.setItem(TOKEN_NAME, JSON.stringify(accessToken));
            console.log('stored');
            
            await this._fetchAndSetCurrentUser();
            this.router.navigate(['/']);
            this.userAuthenticatedChanged.emit(true);
        } catch (error: any) {
            console.error('authenticationService.login:', error);
            let errorMessage;
            switch (error.status) {
                case 401:
                    errorMessage = 'error.login.http.401';
                    break;
                default:
                    errorMessage = 'error.login.http.default';
                    break;
            }
            this.notificationService.error(errorMessage);

        }
    }

    private _setAccessToken(accessToken: any): void {
        localStorage.setItem(TOKEN_NAME, accessToken);
    }

    public logout() {
        localStorage.removeItem(TOKEN_NAME);
        localStorage.removeItem(USER_NAME);
        this.router.navigate(['/welcome']);
        this.userAuthenticatedChanged.emit(false);
        this.navigationService.setmenuLink([]);
    }

    public getAccessToken() {
        const accessToken = localStorage.getItem(TOKEN_NAME);
        if (!accessToken) return false;
        let token = JSON.parse(accessToken);
        this.setUserNavigation(token.role);
        return token.token;
    }

    public getCurrentUser() {
        let userLS = localStorage.getItem(USER_NAME);
        const currentUser = userLS ? JSON.parse(userLS) : null;
        if (!currentUser) {
            localStorage.removeItem(TOKEN_NAME);
            location.reload();
        }
        if(currentUser.id==1) {
            // seb super admin
            currentUser.isAdmin = true;
        }
        return currentUser;
    }

    async _fetchAndSetCurrentUser(): Promise<any> {
        const currentUser = await this.authenticationApi.fetchCurrentUser();
        localStorage.setItem(USER_NAME, JSON.stringify(currentUser));
        return currentUser;
    }

    async setUserNavigation(role:string){
        if (role) {
            let menuRole = menuRoles.find( mnu => mnu.role == role );
            let menu = menuRole.menu || [];
            
            this.navigationService.setmenuLink(menu);
        }
    }

    async forgotPassword(email: string) {
        await this.authenticationApi.forgotPassword(email);
    }


}
